export default __webpack_public_path__ + "static/media/9.3812cad7.jpg";